/* eslint-disable no-nested-ternary */
import React from 'react';
// assets
import { GiFemale, GiMale } from 'react-icons/gi';
import DefaultProfile from '../../../../assets/images/default_profile.jpeg';

function HearroPatientDataSidebar({ patientData, patientProfileImg, handlePatientModify }) {
	console.log('HearroPatientDataSidebar patientData', patientData);
	return (
		<div className="patientManageDetail__patient">
			<button className="patient_edit submitButton__rounded" onClick={handlePatientModify}>
				수정
			</button>
			<div className="patient_profile">
				<img src={patientProfileImg || DefaultProfile} alt="" className="profileImage" />
				<div className="profileName">
					{patientData.sex ? (
						patientData.sex === 'M' ? (
							<GiMale style={{ transform: 'rotate(90deg)', color: '#53a5fc' }} />
						) : (
							<GiFemale style={{ transform: 'rotate(-45deg)', color: '#fc7cb4' }} />
						)
					) : null}
					<span>
						{patientData.displayInitial
							? patientData.displayInitial
							: patientData.displayName
							? patientData.displayName
							: '-'}
						{/* {patientData.nickName ? `(${patientData.nickName})` : null} */}
					</span>
				</div>
			</div>
			<div className="patient_detail colored">
				{/* <div className="patient_detailItem">
					<span>휴대폰 번호</span>
					<span>
						{patientData.phoneNumber
							? `${patientData.phoneNumber.substring(0, 3)}-${patientData.phoneNumber.substring(
									3,
									patientData.phoneNumber.length - 4,
							  )}-${patientData.phoneNumber.substring(
									patientData.phoneNumber.length - 4,
									patientData.phoneNumber.length,
							  )}`
							: '-'}
					</span>
				</div> */}
				<div className="patient_detailItem">
					{/* <span>생년월일</span> */}
					<span>생년월</span>
					{/* <span>
						{patientData.birth
							? `${patientData.birth.substr(0, 4)} 년 ${patientData.birth.substr(
									4,
									2,
							  )} 월 ${patientData.birth.substr(6, 2)} 일`
							: '-'}
					</span> */}
					<span>
						{patientData.birth
							? `${patientData.birth.substr(0, 4)} 년 ${patientData.birth.substr(4, 2)} 월`
							: '-'}
					</span>
				</div>
				{/* <div className="patient_detailItem">
					<span>처방코드</span>
					<span>{patientData.psctCode ? patientData.psctCode : '-'}</span>
				</div> */}
				<div className="patient_detailItem">
					<span>스크리닝 no.</span>
					<span>{patientData.screeningNumber ? patientData.screeningNumber : '-'}</span>
				</div>
				<div className="patient_detailItem">
					<span>Random no.</span>
					<span>{patientData.randomNumber ? patientData.randomNumber : '-'}</span>
				</div>
				<div className="patient_detailItem">
					<span>Baseline 방문일</span>
					<span>
						{patientData.baselineVisitDate ? patientData.baselineVisitDate.substr(0, 10) : '-'}
					</span>
				</div>
			</div>
			{/* <div className="patient_detail">
				<div className="patient_detail__title">보청기 정보</div>
				{!patientData.serialNum && (
					<div className="patient_detailItem">
						<span>등록한 보청기가 없습니다.</span>
					</div>
				)}
				{patientData.serialNum && (
					<div className="patient_detailItem">
						<span>시리얼 넘버</span>
						<span>{patientData.serialNum ? patientData.serialNum : '-'}</span>
					</div>
				)}
				{patientData.serialNum && (
					<div className="patient_detailItem">
						<span>수령일</span>
						<span>
							{patientData.hearAidGetDate ? patientData.hearAidGetDate.substr(0, 10) : '-'}
						</span>
					</div>
				)}
				{patientData.serialNum && (
					<div className="patient_detailItem">
						<span>최근 피팅일</span>
						<span>
							{patientData.hearAidFitDate ? patientData.hearAidFitDate.substr(0, 10) : '-'}
						</span>
					</div>
				)}
			</div> */}
			<div className="patient_detail">
				<div className="patient_detail__title">어플 사용 정보</div>
				{/* <div className="patient_detailItem">
					<span>게임 총 훈련 시간</span>
					{patientData.trainAmount ? (
						<span>
							{patientData.trainAmount >= 60
								? `${Math.floor(patientData.trainAmount / 60)}시간 `
								: null}
							{patientData.trainAmount % 60}분
						</span>
					) : (
						<span>0분</span>
					)}
				</div>
				<div className="patient_detailItem">
					<span>어플 시작일</span>
					<span>
						{patientData.startDate
							? `${patientData.startDate.substr(0, 4)}-${patientData.startDate.substr(
									4,
									2,
							  )}-${patientData.startDate.substr(6, 2)}`
							: '-'}
					</span>
				</div> */}
				<div className="patient_detailItem">
					<span>30분 이상 훈련한 일수</span>
					{/* <span>{patientData.completeCount ? patientData.completeCount : '0'}일</span> */}
				</div>
				<div className="training_sub_items">
					<div className="training_sub_item">
						<span>총 회</span>
						<span>
							{patientData.completeCount ? Math.min(patientData.completeCount, 12) : '0'}회 / 12회
						</span>
					</div>
					<div className="training_sub_item">
						<span>총 훈련시간</span>
						<span>
							{patientData.trainAmount ? Math.min(patientData.trainAmount, 360) : '0'}분 / 360분
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default HearroPatientDataSidebar;
